<template>
    <el-date-picker
        v-model="date"
        type="date"
        :format="datePickerFormat"
        valueFormat="yyyy-MM-dd"
        :pickerOptions="datePickerOptions"
        :placeholder="$t.__('common.labels.date')"
    >
    </el-date-picker>
</template>

<script>
import CfMixin from 'mixins/CustomfieldsMixins';
import { createNamespacedHelpers } from 'vuex';
const corpMapGetters = createNamespacedHelpers('corp').mapGetters;

export default {
    mixins: [CfMixin],
    data() {
        return {
            datePickerOptions: {
                disabledDate: this.limitDate,
                firstDayOfWeek: 1,
            },
        };
    },

    computed: {
        ...corpMapGetters(['datePickerFormat']),
        date: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', { id: this.id, value });
            },
        },
    },

    methods: {
        limitDate(date) {
            let result = false;

            if (
                !_.isNil(this.parameters.min_date) &&
                moment(date).isBefore(this.parameters.min_date)
            ) {
                result = true;
            } else if (
                !_.isNil(this.parameters.max_date) &&
                moment(date).isAfter(this.parameters.max_date)
            ) {
                result = true;
            }

            return result;
        },
    },
};
</script>
